import React, { useEffect, useState } from "react";
import { defaultUserImg } from "../../Constants/Images";
import { SpaceTypes } from "../../Constants/Interfaces";
import { Button } from "react-bootstrap";
import MapViewComponent from "../MapViewComponent";
import { defaultMapCenter } from "../../Constants";

interface LocationTabType {
  item: SpaceTypes;
  messageHost: Function;
}

const LocationTab: React.FC<LocationTabType> = ({ item, messageHost }) => {
  const [mapCenter, setMapCenter] = useState(defaultMapCenter);
  const [markers, setMarkers] = useState([]);
  console.log("SpaceItem :", item);

  console.log("mapCenter :", mapCenter);

  useEffect(() => {
    if (item && item.location && item.location.coordinates) {
      const center = {
        lat: item && item?.location?.coordinates[1],
        lng: item && item?.location?.coordinates[0],
      };
      setMapCenter(center);

      setMarkers([
        {
          id: item.id,
          title: `${item.name}`,
          price: item.ratePerHour,
          location: center,
        },
      ]);
    }
  }, [item]);

  return (
    <div className="location-wrapper">
      <h2>Location</h2>

      <MapViewComponent
        id="space-location"
        mapCenter={mapCenter}
        markers={markers}
        mapHeight={300}
        zoomLevel={15}
      />

      <div className="host-details-wrapper">
        <div className="host-info">
          <img src={item?.user?.image || defaultUserImg} alt="" />

          <div className="name-details">
            {item?.user && <h3>Hosted by {item?.user?.name}</h3>}
            {/* <p>Power Host</p> */}
          </div>
        </div>

        <div className="timing-info text-right">
          <Button className="" onClick={() => messageHost()}>
            Message Host
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LocationTab;
